import {Component, Input, OnInit} from '@angular/core';
import {CFASTLINKMAPPERFASTLINK} from "../fastlinkstruct";
import {sprintf} from "sprintf-js";

@Component({
  selector: 'app-fast-link-fast-link',
  templateUrl: './fast-link-fast-link.component.html',
  styleUrls: ['./fast-link-fast-link.component.css']
})
export class FastLinkFastLinkComponent implements OnInit {
  @Input() fastLinkBluePrint: CFASTLINKMAPPERFASTLINK | undefined;
  @Input() fastLinkRunTime: CFASTLINKMAPPERFASTLINK | undefined;
  @Input() offline: boolean | undefined;

  constructor() { }

  ngOnInit(): void {
  }

  ConvertFieldStation(val: number) : number
  {
    return val & 0x7F;
  }

  CompareTypeOfPrint(): boolean {
    if (this.fastLinkRunTime && this.fastLinkBluePrint) {
      if ((this.fastLinkRunTime.status & 0xF) == (this.fastLinkBluePrint.status & 0xF))
      {
          return true;
        }
    }
    return false;
  }

  CompareSizeOfIO(): boolean {
    if (this.fastLinkRunTime && this.fastLinkBluePrint) {
      if(this.fastLinkRunTime.nrOfAIs != this.fastLinkBluePrint.nrOfAIs )
        return false;
      if(this.fastLinkRunTime.nrOfAOs != this.fastLinkBluePrint.nrOfAOs )
        return false;
      if(this.fastLinkRunTime.nrOfDIs != this.fastLinkBluePrint.nrOfDIs )
        return false;
      if(this.fastLinkRunTime.nrOfDOs != this.fastLinkBluePrint.nrOfDOs )
        return false;
      return true;
    }
    return false;
  }


  CompareOffsetOfIO(): boolean {
    if (this.fastLinkRunTime && this.fastLinkBluePrint) {
      if(this.fastLinkRunTime.offsetAI != this.fastLinkBluePrint.offsetAI )
        return false;
      if(this.fastLinkRunTime.offsetAO != this.fastLinkBluePrint.offsetAO )
        return false;
      if(this.fastLinkRunTime.offsetDI != this.fastLinkBluePrint.offsetDI )
        return false;
      if(this.fastLinkRunTime.offsetDO != this.fastLinkBluePrint.offsetDO )
        return false;
      return true;
    }
    return false;
  }

  CompareFastLinkPrint() : string
  {
    if(this.offline )
      return "offline";
    if(this.CompareTypeOfPrint() == false)
      return "different";
    if(this.CompareSizeOfIO() == false)
      return "different";
    if(this.CompareOffsetOfIO() == false)
      return "different";
    return "online";
  }

  //Status: [Present,Failure,Double,Old,Ao,Ai,Do,Di]
   GetFunction(status: number): string
   {
     var str: string = "";
     str+= (status & 0x1 ) ? "di" : "--";
     str+= (status & 0x2 ) ? "do" : "--";
     str+= (status & 0x4 ) ? "ai" : "--";
     str+= (status & 0x8 ) ? "ao" : "--";
     return str;

   }

  //Status: [Present,Failure,Double,Old,Ao,Ai,Do,Di]
  GetStatus(status: number): string
  {
    var str: string = "";
    str+= (status & 0x80 ) ? "P" : "-";
    str+= (status & 0x40 ) ? "F" : "-";
    str+= (status & 0x20 ) ? "D" : "-";
    str+= (status & 0x10 ) ? "O" : "-";
    return str;
  }

  GetStation(station: number): string
  {
      return sprintf("%02d", station);
  }

}
